
import { css } from 'lit';
export default css`
:host {
  position: relative;
  z-index: 9998;
}@media (min-width: 1024px) {:host {
    position: fixed;
  }:host {
    left: 0px;
  }:host {
    top: 3rem;
  }
}@media (min-width: 1024px) {:host {
    top: var(--topAlign)
}
  }@media screen and (min-width: 1664px) {:host {
    left: auto;
    margin-left: calc(-10.8em + 11px)
}
  }

.main-navigation {
  position: relative;
  display: flex;
  align-items: flex-start;
  border-top-width: 1px;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(109, 89, 149, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 1024px) {.main-navigation {
    width: 5.5rem;
  }.main-navigation {
    flex-direction: row;
  }.main-navigation {
    border-top-width: 1px;
  }.main-navigation {
    border-bottom-width: 1px;
  }.main-navigation {
    --tw-border-opacity: 1;
    border-color: rgba(109, 89, 149, var(--tw-border-opacity));
  }
}

@media (min-width: 1200px) {.main-navigation {
    width: 7rem;
  }
}

.main-navigation.main-navigation--hp {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.main-navigation.main-navigation--hp.main-navigation--item {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.main-navigation--mlp {
    display: block;
  }

@media (min-width: 1024px) {

.main-navigation--mlp {
      display: none
  }
    }

.main-navigation--list {
  margin: 0px;
}

.main-navigation--list {
  width: 100%;
}

.main-navigation--list {
  padding: 0px;
}

.main-navigation--list {
    max-height: calc(100vh - var(--topAlign));
    overflow: auto;
  }

.main-navigation--item {
  font-size: 0.875rem;
}

.main-navigation--item {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.main-navigation--item:last-child {
  border-bottom-width: 0px;
}

@media (min-width: 1024px) {.main-navigation--item {
    display: inline-block;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    width: 100%;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    align-items: center;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    border-width: 0px;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    border-bottom-width: 1px;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    border-right-width: 1px;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    border-style: solid;
  }
}

@media (min-width: 1024px) {.main-navigation--item {
    --tw-border-opacity: 1;
    border-color: rgba(109, 89, 149, var(--tw-border-opacity));
  }
}

@media (min-width: 1024px) {.main-navigation--item:not(:first-child) {
    display: inline-block;
  }
}

@media (min-width: 1200px) {.main-navigation--item {
    font-size: 1rem;
  }
}

@media (max-width: 1023px) {.main-navigation--item:not(:first-child) {
    display: none;
  }
}

.main-navigation--item--open {
  border-right-width: 0px;
}

.main-navigation--item--open {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.main-navigation--link {
  display: flex;
}

.main-navigation--link {
  text-transform: uppercase;
}

.main-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.main-navigation--link {
  text-decoration: none;
}

@media (min-width: 1024px) {.main-navigation--link {
    height: 5.5rem;
  }
}

@media (min-width: 1024px) {.main-navigation--link {
    flex-direction: column;
  }
}

@media (min-width: 1024px) {.main-navigation--link {
    align-items: center;
  }
}

@media (min-width: 1024px) {.main-navigation--link {
    justify-content: center;
  }
}

@media (min-width: 1024px) {.main-navigation--link {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

@media (min-width: 1024px) {.main-navigation--link {
    font-size: 0.75rem;
  }
}

@media (min-width: 1200px) {.main-navigation--link {
    height: 6rem;
  }
}

@media (min-width: 1200px) {.main-navigation--link {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

@media (min-width: 1200px) {.main-navigation--link {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}

.main-navigation--link:hover {
  cursor: pointer;
}

.main-navigation--link:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.main-navigation.main-navigation--hp .main-navigation--item {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

@media (min-width: 1024px) {.main-navigation.main-navigation--hp .main-navigation--item {
    border-left-width: 1px;
  }
}

@media (min-width: 1024px) {.main-navigation.main-navigation--hp .main-navigation--item {
    --tw-border-opacity: 1;
    border-color: rgba(232, 194, 255, var(--tw-border-opacity));
  }
}

.main-navigation.main-navigation--hp .main-navigation--item .main-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.main-navigation.main-navigation--hp .main-navigation--item .main-navigation--link:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

.main-navigation.main-navigation--hp .main-navigation--item .main-navigation--link:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.main-navigation.main-navigation--hp .main-navigation--item--open .main-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.main-navigation.main-navigation--hp.active {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.main-navigation.main-navigation--hp.active .main-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.main-navigation--icon {
    /* ie11 fix */
  }

.main-navigation--icon {
  height: 1.5rem;
}

.main-navigation--icon {
  width: 1.5rem;
}

.main-navigation--text {
    /* ie11 fix */
  }

.main-navigation--text {
  max-width: 100%;
}

.main-navigation--text {
  padding-top: 0.5rem;
}

.main-navigation--text {
  font-family: Lato, sans-serif;
}

@media (min-width: 1024px) {.main-navigation--text {
    text-align: center;
  }
}

.main-navigation--mobile {
  display: inline-flex;
}

.main-navigation--mobile {
  border-width: 0px;
}
`;